export function isValidISOString(dateString: string): boolean {
  // Reject if slashes exist anywhere (common non-ISO format)
  if (dateString.includes('/') || dateString.includes('|')) {
    return false
  }

  // Check dots only in the date part (before 'T' or entire string if no time)
  const datePart = dateString.split('T')[0] // Get date part before time
  if (datePart.includes('.')) {
    return false
  }

  const date = new Date(dateString)
  return !isNaN(date.getTime())
}
